import { GiBoomerangCross } from "react-icons/gi";

export const links = [
  {
    id: 1,
    text: "home",
    url: "/",
  },
  {
    id: 2,
    text: "shipping",
    url: "/shipping",
  },
  {
    id: 3,
    text: "products",
    url: "/products",
  },
];

export const services = [
  {
    id: 1,
    icon: <GiBoomerangCross />,
    title: "Gear",
    text: "toy text",
  },
  {
    id: 2,
    icon: <GiBoomerangCross />,
    title: "clothing",
    text: "clothing text",
  },
  {
    id: 3,
    icon: <GiBoomerangCross />,
    title: "accessories",
    text: "accessories text",
  },
];

export const API_ENDPOINT =
  "https://mqcyqq2c.api.sanity.io/v1/graphql/production/default";

export const QUERY = `
{
  allProduct {
    _id
    name
    slug {
      current
    }
    brand
    categories {
      categories
    }
    clothingCategories {
      clothingCategories
    }
    price
    stock
    forWhom {
      forWhom
    }
    height {
      height
    }
    heightDescription
    age {
      age
    }
    ageDescription
    itemDescription
    featured
    images {
      asset {
        url
      }
    }
  }
}

`;
